module.exports = __webpack_public_path__ + "img/halteknop01.9144d881.png";